export default class RepLegacyController {
	/* @ngInject */
	constructor(
		$scope,
		$state,
		$uibModal,
		registresLegacyService,
		globalizationManagementService,
		PaginationService,
		notification,
		$translate,
		moment,
		ModalService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.moment = moment;
		this.ModalService = ModalService;
		this.registresLegacyService = registresLegacyService;
		this.PaginationService = PaginationService;
		this.loading = false;
		this.unregister = [];

		this.registresType = {
			ECO_ORGANISME_REGISTRE_ENRICHI: 'Eco organisme - Registre enrichi',
			DECLARATION_ECOMINERO: 'Déclaration écominéro'
			// ECO_ORGANISME_DECLARATION_MENSUELLE: 'Eco organisme - Déclaration mensuelle',
			// RNDTS_TEXS_ENTRANT: 'RNDTS - TEXS Entrant',
			// RNDTS_TEXS_SORTANT: 'RNDTS - TEXS Sortant',
			// RNDTS_DD_ENTRANT: 'RNDTS - DD Entrant',
			// RNDTS_DD_SORTANT: 'RNDTS - DD Sortant'
		};

		//pour l'envois du type de registre rndts au back, doit être identique à la valeur de la clé dans this.registresType
		this.registresRndtsType = Object.freeze({
			RNDTS_TEXS_ENTRANT: 1,
			RNDTS_TEXS_SORTANT: 2,
			RNDTS_DD_ENTRANT: 3,
			RNDTS_DD_SORTANT: 4
		});

		this.slideWidth = '500px';
		this.slideMargin = {
			'margin-right': '0px',
			'transition-duration': '0.5s',
			'transition-animation': 'margin-right',
			height: '100%'
		};

		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.declarationRndts = [];
		this.societes = [];
		this.sites = [];
		this.clients = [];
		this.idClients = [];
	}

	async $onInit() {
		await this.loadSocietes();
		await this.loadClients();

		await this.loadEcoOrganismes();
		this.setLastMonthDate();

		this.unregister.push(
			this.$scope.$watch(
				() => this.idSociete,
				() => {
					if (this.idSociete && this.idSociete > 0) {
						this.declarationRndts = [];
						this.sites = [];
						this.idSite = null;
						this.loadSitesBySocieteId(this.idSociete);
					}
				},
				true
			)
		);
		this.unregister.push(
			this.$scope.$watch(
				() => this.selectedRegistreType,
				() => {
					this.idSociete = null;
					this.sites = [];
					this.idSite = null;
					this.idEcoOrganisme = null;
					this.declarationRndts = [];
				},
				true
			)
		);
		this.unregister.push(
			this.$scope.$watch(
				() => this.idSite,
				() => {
					if (this.idSite && this.idSite > 0) {
						this.declarationRndts = [];
					}
				},
				true
			)
		);
	}

	$onDestroy() {
		for (const un of this.unregister) {
			un();
		}
	}

	setLastMonthDate() {
		const maDate = new Date();
		const dates = this.getPreviousMonthDates(maDate);
		this.dateDebut = dates.start;
		this.dateFin = dates.end;
	}

	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.registresLegacyService.getSocietes();
			if (this.societes.length == 1) {
				this.idSociete = this.societes[0].id;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}
	async loadSitesBySocieteId(idSociete) {
		this.startLoading();
		try {
			this.sites = await this.registresLegacyService.getSitesBySocieteId(idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadClients() {
		this.startLoading();
		try {
			this.clients = await this.registresLegacyService.getClients();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadEcoOrganismes() {
		this.startLoading();
		try {
			this.ecoOrganismesList = await this.registresLegacyService.getAllEcoOrganismes();
		} catch (ex) {
			this.notification.error(ex);
		} finally {
			this.stopLoading();
		}
	}

	checkDateError() {
		let momentDebut = this.moment(this.dateDebut, 'DD/MM/YYYY');
		let momentFin = this.moment(this.dateFin, 'DD/MM/YYYY');
		let date2026 = this.moment('01/01/2026', 'DD/MM/YYYY');
		if (momentDebut < date2026 && momentFin >= date2026) {
			this.dateError = true;
		} else {
			this.dateError = false;
		}
	}

	async exportRegistreEcoOrganismes() {
		this.checkDateError();
		if (this.dateError) return;
		if (this.idSociete && this.dateDebut && this.dateFin) {
			this.startLoading();
			const form = {
				idSociete: this.idSociete,
				idSite: this.idSite || -1,
				idEcoOrganisme: this.idEcoOrganisme || -1,
				dateDebut: this.dateDebut,
				dateFin: this.dateFin,
				idClients: this.idClients
			};
			try {
				const fileData =
					this.selectedRegistreType === 'ECO_ORGANISME_REGISTRE_ENRICHI'
						? await this.registresLegacyService.exportRegistreEcoOrganismes(form)
						: await this.registresLegacyService.exportRegistreDeclarationEcominero(form);
				if (fileData) {
					const fileName =
						this.selectedRegistreType === 'ECO_ORGANISME_REGISTRE_ENRICHI'
							? 'registre-eco-organismes.xlsx'
							: 'registre-declaration-ecominero.xlsx';
					const blob = new Blob([fileData.data], {
						type: fileData.headers()['content-type'] + ';charset=UTF-8'
					});
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = fileName;

					link.dispatchEvent(
						new MouseEvent('click', {
							view: window,
							bubbles: true,
							cancelable: false
						})
					);
				}
			} catch (ex) {
				console.warn(ex);
				this.notification.error(this.$translate.instant('REGISTRES.ERROR.NO_BL'));
			} finally {
				this.stopLoading();
			}
		} else {
			this.notification.error(this.$translate.instant('REGISTRES.ERROR.MISSING_FIELDS'));
		}
	}

	// Arrow fx for bind
	loadDeclarationRndts = async () => {
		if (this.dateDebut && this.dateFin && this.idSociete && this.selectedRegistreType) {
			this.startLoading();

			const filters = this.PaginationService.getFilters(this.previousTableState);
			const sorts = this.PaginationService.getSorts(this.previousTableState);

			this.declarationRndts = [];
			this.declarationRndtsWithMeta = {};

			try {
				const data = await this.registresLegacyService.getDeclarationRndts(
					filters,
					sorts,
					null,
					this.idSociete,
					this.idSite,
					this.dateDebut,
					this.dateFin,
					this.getTypeEntreeSortie(),
					this.getRndtsType()
				);
				this.declarationRndtsWithMeta = data;
				this.declarationRndts = data.declarationRndts.items;

				if (this.previousTableState) {
					this.PaginationService.setTableState(data.skip, data.take, data.total, this.previousTableState);
				}
				// console.log('Declaration Count', this.declarationRndts);
			} catch (ex) {
				this.notification.error(ex.data);
			} finally {
				this.stopLoading();
			}
		}
	};

	getTypeEntreeSortie() {
		return this.selectedRegistreType === 'RNDTS_TEXS_SORTANT' || this.selectedRegistreType === 'RNDTS_DD_SORTANT' ? 1 : 0;
	}

	// getIsDechetsDangereux() {
	// 	return this.selectedRegistreType === 'RNDTS_DD_ENTRANT' || this.selectedRegistreType === 'RNDTS_DD_SORTANT';
	// }

	getRndtsType() {
		return this.registresRndtsType[this.selectedRegistreType];
	}

	// redirectToDAP(id) {
	// 	let url = this.$state.href('daps.edit', { id: id });
	// 	window.open('gestion.html' + url);
	// }

	// redirectToTicket(id) {
	// 	let url = this.$state.href('tickets.detail', { id: id });
	// 	window.open('gestion.html' + url);
	// }

	async printDeclarationRndts() {
		if (this.dateDebut && this.dateFin && (this.idSite || this.idSociete)) {
			this.startLoading();
			const fileName = Date.now();
			const resultat = await this.registresLegacyService.printDeclarationRndts(
				this.idSociete,
				this.idSite,
				this.dateDebut,
				this.dateFin,
				this.getTypeEntreeSortie(),
				this.getRndtsType(),
				fileName
			);

			const data = resultat.data;
			let headers = resultat.headers;

			headers = headers();

			const contentType = headers['content-type'];

			const linkElement = document.createElement('a');
			try {
				const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
				const url = window.URL.createObjectURL(blob);
				linkElement.setAttribute('href', url);
				linkElement.setAttribute('download', fileName + '.csv');

				const clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: false
				});
				linkElement.dispatchEvent(clickEvent);
			} catch (ex) {
				console.log('🔥: RegistresController -> printDeclarationRndts -> ex', ex);
			} finally {
				this.stopLoading();
			}
		}
	}

	async teletransmetre() {
		this.notification.info(this.$translate.instant('REGISTRES.API_CALLBACK.SEND_API'));
		const apiResult = await this.registresLegacyService.postApi(
			this.idSociete,
			this.idSite,
			this.dateDebut,
			this.dateFin,
			this.getTypeEntreeSortie(),
			this.getRndtsType()
		);
		this.registresLegacyService.setApiResult(apiResult);
		let shouldOpen = false;
		this.loadDeclarationRndts();
		for (let k in apiResult) {
			shouldOpen = apiResult[k].httpCode > 200;
		}

		if (shouldOpen) {
			this.$uibModal
				.open({
					template: `<rndts-api-callback modal-instance="$ctrl.uibModalInstance"></rndts-api-callback>`,
					controller: [
						'$uibModalInstance',
						function ($uibModalInstance) {
							const $ctrl = this;
							$ctrl.uibModalInstance = $uibModalInstance;
						}
					],
					controllerAs: '$ctrl',
					size: 'xxl'
				})
				.result.then(async function (result) {
					if (result) {
						console.log('🔥: RegistresController -> teletransmetre -> result', result);
					}
				});
		}
	}

	openTicket(ticket) {
		this.$uibModal
			.open({
				template: '<ticket-detail modal-instance="$ctrl.uibModalInstance" ticket-from-pre-fa="$ctrl.ticketFromPreFa"></ticket-detail>',
				controller: [
					'$uibModalInstance',
					function ($uibModalInstance) {
						const $ctrl = this;
						$ctrl.uibModalInstance = $uibModalInstance;
						$ctrl.ticketFromPreFa = ticket;
					}
				],
				controllerAs: '$ctrl',
				size: 'xxl'
			})
			.result.then(async function (result) {
				// console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
				console.info(result);
			});
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	isForRndtsTexs() {
		return (
			this.dateFin &&
			this.dateDebut &&
			this.idSociete &&
			(this.selectedRegistreType === 'RNDTS_TEXS_ENTRANT' || this.selectedRegistreType === 'RNDTS_TEXS_SORTANT')
		);
	}

	isForRndtsDd() {
		return (
			this.dateFin &&
			this.dateDebut &&
			this.idSociete &&
			(this.selectedRegistreType === 'RNDTS_DD_ENTRANT' || this.selectedRegistreType === 'RNDTS_DD_SORTANT')
		);
	}

	isForEcoOrganisme() {
		return (
			this.dateFin &&
			this.dateDebut &&
			(this.selectedRegistreType === 'ECO_ORGANISME_REGISTRE_ENRICHI' || this.selectedRegistreType === 'DECLARATION_ECOMINERO')
		);
	}

	getPreviousMonthDates(date) {
		const y = date.getFullYear();
		const m = date.getMonth() - 1;
		const firstDay = new Date(y, m, 1);
		const lastDay = new Date(y, m + 1, 0);
		const formattedFirstDay = this.moment(firstDay).format(this.dateFormat);
		const formattedLastDay = this.moment(lastDay).format(this.dateFormat);
		return { start: formattedFirstDay, end: formattedLastDay };
	}
}
